<template>
  <div class="loading-container">
      <div class="loader">
      <svg viewBox="0 0 36 36" class="circular-chart">
      <path class="circle-bg"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path class="circle"
        :stroke-dasharray="progress+', 100'"
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
    </svg>
  </div>
    <!--<span style="z-index:10">{{progress}}%</span>-->
  </div>
</template>

<script>
// @ is an alias to /src

import { mapGetters} from 'vuex'

export default {
  name: 'loading',
  components: {
  },
  computed:{
    ...mapGetters(['loadingProgress']),
    loadingSlider: function(){
      return {width:this.loadingProgress+'%'};
    },
    progress: function(){
      return Math.round(this.loadingProgress)
    }
  },
  data() {
    return {
    }
  },
  mounted: function(){
  }
}
</script>
<style  lang="scss">
.loader{
  width:20vw;
  height:20vh;
  max-width: 300px;
  min-width: 100px;
  max-height: 300px;
  min-height: 100px;
}
.loading-container{
  position: fixed;
  left:0px;
  top:0px;
  width:100vw;
  height:100vh;
  background:black;
  z-index:1000;
  display:flex;
  align-items: center;
  justify-content: center;
}
.flex-wrapper {
  display: flex;
  flex-flow: row nowrap;
}

.single-chart {
  width: 33%;
  justify-content: space-around ;
}

.circular-chart {
  display: block;
  margin: 10px auto;
  max-width: 60px;
  max-height: 60px;
}

.circle-bg {
  fill: none;
  stroke: #ffffff;
  stroke-width: 1;
}

.circle {
  fill: none;
  stroke-width: 2.8;
  stroke-linecap: round;
  transition:4s;
}

@keyframes progress {
  0% {
    stroke-dasharray: 0 100;
  }
}

.circular-chart .circle {
  stroke: rgb(255, 96, 99);
}

</style>
